/**
 * Static registry of dashboard routes (core routes) that have explicit tool ownership
 * This maps route names to their Totem tool IDs
 *
 * NOTE: This is a TEMPORARY solution until we move the tools out of dashboard
 * into their respective domains.
 */
export const DASHBOARD_ROUTE_TOOLS: Record<string, string> = {
  aisles: 'departments-dashboard-tool',
  'new-aisle': 'departments-dashboard-tool',
  'edit-aisle': 'departments-dashboard-tool',
  aisle: 'departments-dashboard-tool',
  departments: 'departments-dashboard-tool',
  'new-product-request': 'legacy-new-product-request-dashboard-tool',
  product: 'legacy-product-dashboard-tool',
  editProduct: 'legacy-product-dashboard-tool',
  search: 'legacy-product-search-dashboard-tool',
  'new-search': 'legacy-product-search-dashboard-tool',
  'search-results': 'legacy-product-search-dashboard-tool',
  reports: 'inventory-files-dashboard-tool',
  subscriptions: 'inventory-files-dashboard-tool',
  transactions: 'inventory-files-dashboard-tool',
  files: 'inventory-files-dashboard-tool',
  'alcohol-tlogs': 'alcohol-delivery-logs-dashboard-tool',
  stripeSettings: 'ipp-platform',
  productEditDetails: 'legacy-product-dashboard-tool',
  productEditAisles: 'legacy-product-dashboard-tool',
  productEditLocations: 'legacy-product-dashboard-tool',
  insightsPortal: 'legacy-store-labor-performance-tool',
  'store-groups': 'store-groups-dashboard-tool',
  'store-groups-add': 'store-groups-dashboard-tool',
  'store-groups-edit': 'store-groups-dashboard-tool',
  base: 'ipp-platform',
  logout: 'ipp-platform',
  'stripe-connect-callback': 'ipp-platform',
  scope: 'ipp-platform',
  'partner-scoped': 'ipp-platform',
  'retailer-scoped': 'ipp-platform',
  'log-out': 'ipp-platform',
  public: 'authentication-dashboard-tool',
  app: 'ipp-platform',
  'app-halt': 'ipp-platform',
  'app-halt-redirect': 'ipp-platform',
  'partner-halt-terms': 'ipp-platform',
  'app-halt-account-limited-access': 'ipp-platform',
  'app-halt-auth-service-account-limited-access': 'ipp-platform',
  'app-halt-account-action-required': 'ipp-platform',
  'app-admin': 'ipp-platform',
  'banner-notifications-list': 'notifications-dashboard-tool',
  dashboard: 'retailer-app-homepage-dashboard-tool',
  'notification-settings': 'notifications-dashboard-tool',
}
